import { HStack, useRadioGroup } from '@chakra-ui/react';
import { useController, useFormContext } from 'react-hook-form';

import { RadioButtonItem } from './RadioButtonItem';

export const RadioButton = ({
  name,
  options,
}: {
  name: string;
  options: {
    value: string;
    label: string;
  }[];
}) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: name,
    value: field.value,
    onChange: field.onChange,
  });

  const group = getRootProps();

  return (
    <HStack
      {...group}
      display="grid"
      gridTemplateColumns={`repeat(${options.length}, 1fr)`}
      gap={6}
    >
      {options.map(({ value, label }) => {
        const radio = getRadioProps({ value });
        return (
          <RadioButtonItem key={value} {...radio}>
            {label}
          </RadioButtonItem>
        );
      })}
    </HStack>
  );
};
